export default __webpack_public_path__ + "static/media/951.2f4bd1e0.gif";